export default __webpack_public_path__ + "img/BB_RTK_NOMA_WF.348f16ca92962fb856ea1bae6a04c8ad.jpg";